<template>
  <div>
    <p class="xPadding titleModal">
      {{ $t(`technicalFile.network.steam.step0.title`) }}
    </p>
    <v-row class="xPadding">
      <v-col
        cols="6"
        class="yPadding"
      >
        <VTextField
          v-model="data.steamPressure.value"
          :label="$t('technicalFile.network.steam.step0.steamPressure')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :disabled="readonly"
          flat
          hideDetails
          data-cy="steamPressure"
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="6"
        class="yPadding"
      >
        <VSelect
          v-model="data.steamPressure.units"
          :label="$t('technicalFile.network.steam.units')"
          :items="displayedUnits('steamPressure')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :disabled="readonly"
          flat
          hideDetails
          data-cy="steamPressureUnits"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        cols="6"
        class="yPadding"
      >
        <VSelect
          v-model="data.fuelSource"
          :label="$t('technicalFile.network.steam.step0.fuelSource')"
          :items="displayedUnits('fuelSource')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :disabled="readonly"
          flat
          hideDetails
          data-cy="fuelSource"
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="6"
        class="yPadding"
      >
        <VTextField
          v-model="data.fuelSourceOther"
          :label="$t('technicalFile.network.steam.step0.fuelSourceOther')"
          :disabled="!isOtherOption('fuelSource') || readonly"
          class="text-field-transparent"
          outlined
          flat
          hideDetails
          data-cy="hotReturnTemp"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        cols="6"
        class="yPadding"
      >
        <VTextField
          v-model="data.operation.value"
          :label="$t('technicalFile.network.steam.step0.operation')"
          :formatNumber="true"
          class="text-field-transparent"
          type="number"
          min="0"
          outlined
          :disabled="readonly"
          flat
          hideDetails
          data-cy="operation"
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="6"
        class="yPadding"
      >
        <VSelect
          v-model="data.operation.units"
          :label="$t('technicalFile.network.steam.units')"
          :items="displayedUnits('operationSteam')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :disabled="readonly"
          flat
          hideDetails
          data-cy="operationUnits"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        cols="6"
        class="yPadding"
      >
        <VSelect
          v-model="data.boilerConfiguration"
          :label="$t('technicalFile.network.steam.step0.boilerConfiguration')"
          :items="displayedUnits('boilerConfiguration')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :disabled="readonly"
          flat
          hideDetails
          data-cy="boilerConfiguration"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        cols="6"
        class="yPadding"
      >
        <VSelect
          v-model="data.steamUsed"
          :label="$t('technicalFile.network.steam.step0.steamUsed')"
          :items="displayedUnits('steamUsed')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :disabled="readonly"
          flat
          hideDetails
          data-cy="steamUsed"
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="6"
        class="yPadding"
      >
        <VTextField
          v-model="data.steamUsedOther"
          :label="$t('technicalFile.network.steam.step0.steamUsedOther')"
          :disabled="!isOtherOption('steamUsed') || readonly"
          class="text-field-transparent"
          outlined
          flat
          hideDetails
          data-cy="steamUsedOther"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        cols="4"
        class="yPadding"
      >
        <VTextField
          v-model="data.steamProduction.value"
          :label="$t('technicalFile.network.steam.step0.steamProduction')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :disabled="readonly"
          flat
          hideDetails
          data-cy="steamProduction"
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="4"
        class="yPadding"
      >
        <VSelect
          v-model="data.steamProduction.units"
          :label="$t('technicalFile.network.steam.units')"
          :items="displayedUnits('steamProduction')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :disabled="readonly"
          flat
          hideDetails
          data-cy="steamProductionUnits"
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="4"
        class="yPadding"
      >
        <VSelect
          v-model="data.timeUnit"
          :label="$t('technicalFile.network.steam.step0.timeUnit')"
          :items="displayedUnits('timeUnit')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :disabled="readonly"
          flat
          hideDetails
          data-cy="timeUnit"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        cols="6"
        class="yPadding"
      >
        <VSelect
          v-model="data.feedwaterPumpOperation"
          :label="$t('technicalFile.network.steam.step0.feedwaterPumpOperation')"
          :items="displayedUnits('feedwaterPumpOperation')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :disabled="readonly"
          flat
          hideDetails
          data-cy="feedwaterPumpOperation"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        cols="6"
        class="yPadding"
      >
        <VTextField
          v-model="data.markeup"
          :label="$t('technicalFile.network.steam.step0.makeup')"
          :formatNumber="true"
          class="text-field-transparent"
          type="number"
          min="0"
          outlined
          :disabled="readonly"
          flat
          hideDetails
          data-cy="markeup"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        cols="6"
        class="yPadding"
      >
        <VSelect
          v-model="data.makeupSource"
          :label="$t('technicalFile.network.steam.step0.makeupSource')"
          :items="displayedUnits('makeupSource')"
          type="number"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :disabled="readonly"
          flat
          hideDetails
          data-cy="makeupSource"
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="6"
        class="yPadding"
      >
        <VTextField
          v-model="data.makeupSourceOther"
          :label="$t('technicalFile.network.steam.step0.makeupSourceOther')"
          :disabled="!isOtherOption('makeupSource') || readonly"
          class="text-field-transparent"
          outlined
          flat
          hideDetails
          data-cy="makeupSourceOther"
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';

export default {
    name: 'Steam',
    components: {
        VTextField,
    },
    props: {
        steamIdentification: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {},
        };
    },
    computed: {
        ...mapGetters([
            'units',
        ]),
    },
    watch: {
        steamIdentification: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.steamIdentification) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { steamIdentification: this.data });
        },
        displayedUnits(type) {
            return this.units && this.units[type] ? this.units[type] : [];
        },
        isOtherOption(field) {
            return this.data[field] === -1;
        },
    },
};
</script>
<style lang="scss" scoped>
.xPadding{
  padding: 0 6rem;
}
.yPadding {
  padding: 5px 0 5px 10px;
}
@media screen and (max-width: 600px) {
   .xPadding{
      padding: 0;
    }
}
</style>
